module.exports = __webpack_public_path__ + "media/images/ic-diversity-f9150b1be7714f3b6b512940c8cf7dc9.svg";